import { Typography, Box } from '@mui/material';

import { useStyles } from './useStyles';

interface IKeyValuePairComponent {
  slice: any;
}

const KeyValuePairComponent = ({ slice }: IKeyValuePairComponent) => {
  const { primary, items } = slice || {};
  const classes = useStyles();

  return (
    <Box className={classes.mainContainer}>
      <Box className={classes.container}>
        <Box className={classes.itemContainer}>
          {primary?.title ? (
            <Typography
              variant="h3"
              align="left"
              color="cinnamon.main"
              mb={{ md: '20px' }}
            >
              {primary?.title}
            </Typography>
          ) : null}
          {items?.map((item: any) => (
            <Box className={classes.item} key={item.key}>
              <Typography
                variant="body2"
                align="justify"
                color="cumin.main"
                className={classes.key}
              >
                {item.key}
              </Typography>
              <Typography
                variant="body2"
                align="justify"
                color="garamMasala.main"
                maxWidth="700px"
              >
                {item.value}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default KeyValuePairComponent;
